import axiosConfig from '../../../redux/Project/axiosConfig';

/**
 * Fetch setup pipe details for one project (same endpoint as Redux getAllPipeDetails).
 * Used so Pipe Fitter can load many projects in parallel without sharing Redux pipeDetails.
 */
export async function fetchAllPipeDetails(
  projectId: string | number
): Promise<Record<string, unknown>> {
  const url = `/pipeDetails/getAllPipeDetails?project_id=${projectId}`;
  const res = await axiosConfig.get(url);
  if (res.status !== 200) {
    throw new Error('Failed to fetch pipe details');
  }
  const data = res?.data?.data;
  if (!data || typeof data !== 'object' || Array.isArray(data)) {
    return {};
  }
  return data as Record<string, unknown>;
}
